import useStore from "config/store";
import useAccountingFirmPermissions from "hooks/Permissions/useAccountingFirmPermissions";
import useCompanyPermissions from "hooks/Permissions/useCompanyPermissions";
import useGeneralPermissions from "hooks/Permissions/useGeneralPermissions";
import { useTranslation } from "react-i18next";
import AccountingFirms from "resources/images/accounting-firms.svg?react";
import Companies from "resources/images/companies.svg?react";
import Users from "resources/images/users.svg?react";

export function useMenuItems() {
  const { t } = useTranslation();
  const userData = useStore(state => state.userData);

  const { canDisplayUser, canDisplayAllUsers } = useGeneralPermissions();
  const { canDisplayCompaniesList } = useCompanyPermissions();
  const { canDisplayAccountingFirms } = useAccountingFirmPermissions();

  const isClient =
    userData?.userCategory?.slug === "client" ||
    userData?.userCategory?.slug === "client-without-accounting";

  if (isClient) return [];

  const items = [
    canDisplayAccountingFirms && {
      label: t("Accounting Firms"),
      icon: <AccountingFirms />,
      href: "/accounting-firms",
    },
    canDisplayUser && {
      label: canDisplayAllUsers ? t("Users") : t("Collaborators"),
      icon: <Users />,
      href: "/users",
    },
    canDisplayCompaniesList && {
      label: t("Companies"),
      icon: <Companies />,
      href: "/companies",
    },
  ];

  return items.filter((item): item is Exclude<typeof item, false> => Boolean(item));
}
